import { FormattedMessage } from 'react-intl';
import { Box } from '@tink/core/src/components/atoms/Box/Box';
import { Text } from '../../../components/atoms/Text/Text';
import { Badge } from '../../../components/atoms/Badge/Badge';
import { DemoBankScenario } from '../../../models/demobankScenarios';
import { H2 } from '../../../components/atoms/Heading/Heading';
import { messages } from './messages';
import { List, ListItem, ListItemHeader, StyledButton } from './ScenariosList.styles';

export type ScenariosListProps = {
  scenarios: DemoBankScenario[];
  onClick: (scenarioId: string) => void;
};

export const ScenariosList = ({ scenarios, onClick }: ScenariosListProps) => {
  return (
    <Box pt="normal">
      <H2>
        <FormattedMessage {...messages.predeterminedScenarios} />
      </H2>
      <List>
        {scenarios.map((s, i) => (
          <ListItem key={s.id}>
            <StyledButton onClick={() => onClick(s.id)} data-testid="scenario-button">
              <ListItemHeader>
                <Text bold color="primary">
                  <FormattedMessage {...messages.scenarioNumber} values={{ number: i + 1 }} />
                </Text>
                {s.errorCondition === null && (
                  <Badge>
                    <FormattedMessage {...messages.success} />
                  </Badge>
                )}
                {s.errorCondition !== null && (
                  <Badge>
                    <FormattedMessage {...messages.error} />
                  </Badge>
                )}
              </ListItemHeader>
              <Text>{s.description}</Text>
            </StyledButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export type CustomScenarioProps = {
  onClick: () => void;
};

export const CustomScenario = ({ onClick }: CustomScenarioProps) => {
  return (
    <Box pt="normal">
      <List>
        <ListItem>
          <StyledButton onClick={() => onClick()} data-testid="custom-scenario-button">
            <ListItemHeader>
              <Text bold color="primary">
                <FormattedMessage {...messages.allScenarios} />
              </Text>

              <Badge>
                <FormattedMessage {...messages.custom} />
              </Badge>
            </ListItemHeader>
            <Text>
              <FormattedMessage {...messages.allScenariosDescription} />
            </Text>
            <Text>
              <FormattedMessage {...messages.demoCredentialsRequired} />
            </Text>
          </StyledButton>
        </ListItem>
      </List>
    </Box>
  );
};
